
<section class="card-information" v-if="card.cardInformation">
  <h4 class="secondary-font">Card Information</h4>

  <p v-html="card.cardInformation" />
</section>
